import React from 'react';
import { Image, Typography, Space } from 'antd';
import { PlayCircleFilled, EyeOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const MediaGridScroll = (props: { mediaItems: any }) => {
  if (!props.mediaItems || props.mediaItems.length === 0) return null;
  
  return (
    <div style={{ padding: '8px 0' }}>
      <Image.PreviewGroup>
        <div style={{
          display: 'flex',
          overflowX: 'auto',
          gap: '10px',
          paddingBottom: '12px',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none'
        }}>
          {props.mediaItems.map((item: any, index: number) => (
            <div 
              key={index} 
              style={{
                height: '250px',
                flex: '0 0 auto',
                position: 'relative',
                borderRadius: '12px',
                overflow: 'hidden',
                border: '1px solid #e8e8e8'
              }}
            >
              <Image
                src={item.thumbnailUrl}
                alt={item.thumbnailLabel}
                preview={{
                  mask: <EyeOutlined style={{ fontSize: '20px' }} />,
                  visible: item.videoUrl ? false : undefined 
                }}
                // CLAVE: Aplicamos estilos tanto al componente como a la imagen real
                style={{
                  height: '250px',
                  width: 'auto',
                  display: 'block',
                  objectFit: 'cover' // Cambiamos a 'cover' para asegurar que llene el alto sin huecos
                }}
                wrapperStyle={{
                  height: '250px' // Forzamos al "wrapper" de Antd a no ser más alto que la imagen
                }}
              />

              {item.videoUrl && (
                <a 
                  href={item.videoUrl} 
                  target="_blank" 
                  rel="noreferrer"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    zIndex: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(0, 0, 0, 0.2)',
                    backdropFilter: 'blur(2px)'
                  }}
                >
                  <PlayCircleFilled style={{ fontSize: '30px', color: '#fff' }} />
                  <b style={{ color: '#fff', fontSize: '10px', marginTop: '4px' }}>VIDEO</b>
                </a>
              )}
            </div>
          ))}
        </div>
      </Image.PreviewGroup>
    </div>
  );
};
